import Vuex from 'vuex'
import Vue from "vue";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    order: 'Hello!'
  },
  mutations: {
    SET_ORDER(state, order) {
      state.order = order;
    }
  },
});